export const currencySymbols = {
    '1': '€',
    '2': '¥',
    '3': '₺',
    '4': '£',
    '5': '₽',
    '6': 'zł',
    '7': '₪',
    '8': 'R$',
    '9': '₹',
    '10': '₦',
    '11': '$',
};

export const currencyLabels = {
    '1': 'Euro',
    '2': 'Yen',
    '3': 'Turkish Lira',
    '4': 'Pound Sterling',
    '5': 'Russian Ruble',
    '6': 'Polish Zloty',
    '7': 'Israeli Shekel',
    '8': 'Brazilian Real',
    '9': 'Indian Rupee',
    '10': 'Nigerian Naira',
    '11': 'US Dollar',
};

export const frequencyLabels = {
    per_hour: 'Per Hour',
    per_month: 'Per Month',
    per_year: 'Per Year',
};

export const categoryMap = {
    '1': 'Other',
    '2': 'Admin & Office',
    '3': 'Art & Design',
    '4': 'Business Operations',
    '5': 'Cleaning & Facilities',
    '6': 'Community & Social Services',
    '7': 'Computer & Data',
    '8': 'Construction & Mining',
    '9': 'Education',
    '10': 'Farming & Forestry',
    '11': 'Healthcare',
    '12': 'Installation, Maintenance & Repair',
    '13': 'Legal',
    '14': 'Management',
    '15': 'Manufacturing',
    '16': 'Media & Communication',
    '17': 'Personal Care',
    '18': 'Protective Services',
    '19': 'Restaurant & Hospitality',
    '20': 'Retail & Sales',
    '21': 'Science & Engineering',
    '22': 'Sports & Entertainment',
    '23': 'Transportation',
};

export const jobTypeLabels = {
    full_time: 'Full-Time',
    part_time: 'Part-Time',
    internship: 'Internship'
};

